import React from 'react';
import PropTypes from 'prop-types';
import { widgetTypes } from '../../shared/constants/constants';
import barChart from './barChart.svg';
import gauge from './gauge.svg';
import lineGraph from './lineGraph.svg';
import numberWithIndicator from './numberWithIndicator.svg';
import pieChart from './pieChart.svg';
import sankey from './sankey.svg';
import selector from './selector.svg';
import sparkline from './sparkline.svg';
import statusCells from './statusCells.svg';
import table from './table.svg';

// eslint-disable-next-line complexity
function getImage(type) {
    switch (type) {
        case widgetTypes.barGraph: {
            return barChart;
        }
        case widgetTypes.lineGraph: {
            return lineGraph;
        }
        case widgetTypes.gauge: {
            return gauge;
        }
        case widgetTypes.numberWithIndicator: {
            return numberWithIndicator;
        }
        case widgetTypes.pieChart: {
            return pieChart;
        }
        case widgetTypes.sankey: {
            return sankey;
        }
        case widgetTypes.selector: {
            return selector;
        }
        case widgetTypes.sparkline: {
            return sparkline;
        }
        case widgetTypes.statusCells: {
            return statusCells;
        }
        case widgetTypes.table: {
            return table;
        }
        default: {
            return '';
        }
    }
}

export default function SvgImage(props) {
    return <img src={getImage(props.type)} alt="" className="svg-image" />;
}

SvgImage.propTypes = {
    type: PropTypes.string,
};
